import React from "react";

export default function AppFooter() {
    return <footer>
        <a id='github-link' href="https://github.com/gjtiquia/random-quote-machine">
            <img alt="GitHub link" src='./github.svg'></img>
        </a>
    </footer>;
}
